import { List } from 'immutable'

export const selectAuth = (state) => state.auth

export const selectAuthRoles = (state) => state.auth.getIn(['data', 'roleIds'], [])

export const selectAuthPermissions = (state) => state.auth.getIn(['data', 'permissions'], List())
